import { render, staticRenderFns } from "./ICDCodes.vue?vue&type=template&id=ae0fbdc8&scoped=true&"
import script from "./ICDCodes.vue?vue&type=script&lang=js&"
export * from "./ICDCodes.vue?vue&type=script&lang=js&"
import style0 from "./ICDCodes.vue?vue&type=style&index=0&id=ae0fbdc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0fbdc8",
  null
  
)

export default component.exports